<template>
  <v-row
    align="center"
    dense
  >
    <v-col cols="4">
      <ClientSelect
        v-model="client"
        :label="labelClient"
        placeholder="Введіть назву клієнта"
        @input="changeClient"
      />
    </v-col>
    <v-col cols="4">
      <ProjectSelect
        v-model="project"
        :label="labelProject"
        :disabled="!client"
        :client-id="clientId"
        @input="changeFilter"
      />
    </v-col>
    <v-col cols="4">
      <DateRangePicker
        :start.sync="dateFrom"
        :end.sync="dateTo"
        :disabled="loading"
        :filled="false"
        @change="changeFilter"
      />
    </v-col>
  </v-row>
</template>

<script>
import ProjectSelect from "../../catalogs/projects/ProjectSelect.vue";
import DateRangePicker from "@/components/story/DateRangePicker.vue";
import ClientSelect from "../../../components/selects/ClientSelect.vue";

export default {
  components: {
    DateRangePicker,
    ProjectSelect,
    ClientSelect,
  },

  props: ["value", "loading"],
  data: () => ({
    dateFrom: "",
    dateTo: "",
    project: null,
    labelProject: "Фільтр по проекту",
    refresh: "refresh",
    client: null,
    labelClient: "Фільтр по клієнтам",
  }),
  computed: {
    filterReady() {
      return this.dateFrom && this.dateTo && this.client;
    },
    clientId() {
      return this.client?.id ?? null;
    },
  },
  watch: {
    filterReady(val) {
      if (!val) {
        this.$emit("reset");
      }
    },
  },
  methods: {
    changeFilter() {
      if (!this.filterReady) {
        return;
      }

      this.$emit("input", {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        project: {
          id: this.project?.id,
          title: this.project?.title,
        },
        client: this.client,
      });
    },
    changeClient() {
      this.project = null;
    },
  },
};
</script>
